import { render, staticRenderFns } from "./NTSMainPage.vue?vue&type=template&id=7c402eac&scoped=true"
import script from "./NTSMainPage.vue?vue&type=script&lang=js"
export * from "./NTSMainPage.vue?vue&type=script&lang=js"
import style0 from "./NTSMainPage.vue?vue&type=style&index=0&id=7c402eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c402eac",
  null
  
)

export default component.exports